import React from "react";
import styles from "../styles/HowItWorks.module.css";

export default function HowItWorks() {
  const steps = [
    {
      number: "01",
      icon: "👋",
      title: "Add your details",
      description:
        "Start with the employer and employee information. Add a logo too if you want your payslip to look more professional.",
    },
    {
      number: "02",
      icon: "📅",
      title: "Set the pay period",
      description:
        "Choose the dates, payment date, and number of paid or unpaid days for this payslip.",
    },
    {
      number: "03",
      icon: "💶",
      title: "Enter the pay",
      description:
        "Add the employee's earnings and any other deductions. Taxes and statutory contributions are calculated automatically.",
    },
    {
      number: "04",
      icon: "✨",
      title: "Generate your payslip",
      description:
        "Check the net pay, add any notes, and click generate. Your finished payslip is ready as a PDF.",
    },
  ];

  return (
    <section className={styles.howItWorks} id="how-it-works">
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.eyebrow}>Simple by design</span>

          <h2 className={styles.title}>
            Your payslip, <span>made easy.</span>
          </h2>

			 <br />
			 <br />

          <p className={styles.subtitle}>
            Just enter the details,
            let us do the calculations, and generate your payslip.
          </p>

			 <br/>
			 <br/>
			 <br/>

          <p className={styles.title} Styles={{fontSize: "80px"}}>
            How it works?
          </p>
        </div>

        <div className={styles.steps}>
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className={styles.step}>
                <div className={styles.stepTop}>
                  <span className={styles.number}>{step.number}</span>
                  <span className={styles.icon}>{step.icon}</span>
                </div>

                <h3>{step.title}</h3>

                <p>{step.description}</p>
              </div>

              {index < steps.length - 1 && (
                <div className={styles.connector} aria-hidden="true">
                  →
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className={styles.bottom}>
          <p>
            <span>💡</span>
            Everything is calculated as you fill in the form.
          </p>

          <button
            type="button"
            onClick={() =>
              document
                .getElementById("payslip-form")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Create a payslip →
          </button>
        </div>
      </div>
    </section>
  );
}
